import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
const faqs = [{
  q: 'Is IRIS CJIS compliant?',
  a: 'IRIS is built on CJIS-aligned architecture. We utilize AES-256 encryption for data at rest and in transit, implement strict role-based access controls (RBAC), and maintain comprehensive audit logs. Full security documentation is available under NDA.'
}, {
  q: 'Can IRIS be purchased using grant funding?',
  a: 'Yes. Many of our agency partners procure IRIS using state and federal grant programs, such as the Florida Immigration Enforcement Grant. Our team can provide necessary documentation to support your grant application.'
}, {
  q: 'How long does deployment take?',
  a: 'Standard deployments take 2-4 weeks, including custom form configuration, user onboarding, and workflow mapping. Complex deployments with custom integrations may take longer.'
}, {
  q: 'Do you integrate with existing RMS or CAD systems?',
  a: 'IRIS provides secure APIs for integration with modern Records Management Systems (RMS) and Computer-Aided Dispatch (CAD) systems. We also offer migration tools for legacy SharePoint or spreadsheet data.'
}, {
  q: 'Is the platform cloud-based or on-premise?',
  a: 'IRIS is a secure, cloud-native SaaS platform hosted entirely on US-based, government-approved infrastructure to ensure maximum uptime, security, and seamless updates.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-iris-surface border-t border-iris-border" data-id="element-41">
      <Container className="max-w-4xl" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <SectionEyebrow text="FAQ" className="justify-center mb-4" data-id="element-44" />
          <h2 className="text-4xl font-display font-bold text-white" data-id="element-45">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <div key={index} className="border border-iris-border bg-iris-black overflow-hidden" data-id="element-47">
              <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-48">
                <span className="font-display text-lg text-white tracking-wide" data-id="element-49">
                  {faq.q}
                </span>
                {openIndex === index ? <MinusIcon className="w-5 h-5 text-iris-green shrink-0" data-id="element-50" /> : <PlusIcon className="w-5 h-5 text-iris-muted shrink-0" data-id="element-51" />}
              </button>

              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-53">
                    <div className="px-6 pb-6 text-iris-muted text-sm leading-relaxed border-t border-iris-border/50 pt-4" data-id="element-54">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </Container>
    </section>;
}